module.exports = "module.exports = __webpack_public_path__ + \"static/media/header.58c53dcc.template\";"